
<el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
  <el-row class="clients-panel cash-list">
    <el-col :span="20" :offset="2" class="clients-panel-container">
      <el-row class="black-inputs">
        <div class="cash-header">
          <h2>Ouverture et fermeture des services</h2>
          <div class="nav-toggle" @click="showHideScreenServices">
            <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
          </div>
        </div>
        <br>
        <el-row class="dateChooser">
          <el-col :md="{ span: 24 }" :sm="{ span: 24 }" :xs="24">
            <el-date-picker class="datePicker" ref="picker" v-model="datesLocked"
              :picker-options="{ firstDayOfWeek: 1 }" type="daterange" range-separator="au"
              start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
          </el-col>
          <el-col :sm="{ span: 11 }" :xs="24">
            <el-select v-model="serviceState" placeholder="Ouvrir / Fermer">
              <el-option key="0" label="Ouvrir" value="ouvrir">
              </el-option>
              <el-option key="1" label="Fermer" value="fermer">
              </el-option>
            </el-select>
          </el-col>
          <el-col :sm="{ span: 11, offset: 2 }" :xs="24">
            <el-select v-model="serviceLocked" placeholder="Service">
              <el-option v-for="t in getServices" :key="t" :label="t" :value="t">
              </el-option>
            </el-select>
          </el-col>
          <el-col :xs="24" :sm="{ span: 24 }">
            <el-popover v-if="getEntrysIsValid" placement="top" width="200" v-model="popupValid"
              popper-class="popup-delete black-inputs">
              <p>
                Êtes vous sûr de vouloir<br>
                {{ serviceState }} {{ (serviceLocked === 'Tous les services') ? serviceLocked.toLowerCase() : `le
                service du ${serviceLocked.toLowerCase()}` }}<br>
                du {{ dateRenderer(this.datesLocked[0]) }} - {{ dateRenderer(this.datesLocked[1]) }}
              </p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" class="dark" type="primary" @click="popupValid = false">Annuler</el-button>
                <el-button type="primary" size="mini" @click="createNewLockedServiceEntry()">Confirmer</el-button>
              </div>
              <el-button class="primary" slot="reference">Valider</el-button>
            </el-popover>
            <el-button type="primary" :disabled="true" v-if="!getEntrysIsValid">Valider</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-col>
  </el-row>
</el-container>
